"use strict";
// Copyright (c) StrangeBee 2024
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ParentController_1 = __importDefault(require("../ParentController"));
// Generated by https://quicktype.io
class AuthProviderController extends ParentController_1.default {
    constructor() {
        super(...arguments);
        this.endpoints = {
            get: '/v1/admin/config/auth',
        };
    }
    list() {
        throw new Error("Can't list AuthProvider");
    }
    count() {
        throw new Error("Can't count AuthProvider");
    }
    create({}) {
        throw new Error("Can't create AuthProvider!");
    }
    // eslint-disable-next-line
    edit(data) {
        return this.manager.put({ url: this.endpoints.get }, data);
    }
    delete() {
        throw new Error("Can't delete AuthProvider!");
    }
    getConfig() {
        return this.manager.get({
            url: this.endpoints.get,
        });
    }
}
exports.default = AuthProviderController;
